/* @ngInject */
const movementLabels = () => {
  const self = {}

  self.class = 'Mouvement'
  self.title = 'Mouvements'

  self.fields = {
    id: {
      text: 'Id',
    },
    nature: {
      text: 'Nature',
    },
    wagonId: {
      text: 'Numéro wagon',
    },
    wagon: {
      text: 'Numéro wagon',
    },
    date: {
      text: 'Date',
    },
    dateBegin: {
      text: 'Date du mouvement',
    },
    dateEnd: {
      text: 'Jusqu\'au',
    },
    departurePosition: {
      text: 'Position de départ',
    },
    arrivalPosition: {
      text: 'Position d\'arrivée',
    },
    departureRailway: {
      text: 'Voie de départ',
    },
    arrivalRailway: {
      text: 'Voie d\'arrivée',
    },
  }

  self.statements = {
    move: 'Déplacement',
    park: 'Garage',
    unpark: 'Dégarage',
    label: (_size = 0, _point = false) => {
      return 'Mouvement' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
    list: 'Liste des mouvements',
    search: 'Rechercher des mouvements',
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce mouvement ?',
  }

  self.log = {
    delete: {
      success: 'La mouvement a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du mouvement.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucun mouvement ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 mouvement a été trouvé.'
        } else if (_length > 1) {
          return _length + ' mouvements ont été trouvés.'
        }
        return 'Mouvement recherché.'
      },
      failure: 'Une erreur est survenue durant la recherche des mouvements',
      noResult: 'Aucune mouvement ne correspond à cette recherche',
    },
  }

  return self
}

export default movementLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/resources/labels.resource.js